import { useQuery } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';

export const onbevestigdeUrenKeys = {
  all: ['leave-requests', 'onbevestigde-uren'] as const,
};

/**
 * Story 4.3: de onbevestigde uren van het eigen team, voor het blok onder de
 * goedkeuringslijst. Zelfde vorm als `useApprovalQueue` — een lijst die door
 * andermans handelen verandert, dus 30 seconden.
 *
 * Geen `retry`: krijgt deze gebruiker een 403 op dit blok, dan rendert het
 * blok zichzelf weg (AC-6) en heeft opnieuw proberen geen zin.
 */
export function useOnbevestigdeUren() {
  return useQuery({
    queryKey: onbevestigdeUrenKeys.all,
    queryFn: () => verlofApi.getOnbevestigdeUren(),
    staleTime: 1000 * 30,
    retry: false,
  });
}
